"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pattern = exports.Uses = exports.Imperfections = exports.Size = exports.Stretch = exports.Material = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["Individual"] = "Individual";
    SellingUnit["Pack"] = "Pack";
    SellingUnit["By Meter"] = "By Meter";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var Material;
(function (Material) {
    Material["Natural"] = "Natural";
    Material["Synthetic"] = "Synthetic";
    Material["Blend"] = "Blend";
})(Material = exports.Material || (exports.Material = {}));
var Stretch;
(function (Stretch) {
    Stretch["None"] = "None";
    Stretch["2-way"] = "2-way";
})(Stretch = exports.Stretch || (exports.Stretch = {}));
var Size;
(function (Size) {
    Size["Single"] = "Single Width";
    Size["Double"] = "Double Width";
})(Size = exports.Size || (exports.Size = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Scented - Vintage"] = "Scented - Vintage";
    Imperfections["Loose Threads"] = "Loose Threads";
    Imperfections["Stain"] = "Stain";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
var Uses;
(function (Uses) {
    Uses["Collars"] = "Collars";
    Uses["Cuffs"] = "Cuffs";
    Uses["Waistbands"] = "Waistbands";
    Uses["Multi-Use"] = "Multi-Use";
})(Uses = exports.Uses || (exports.Uses = {}));
var Pattern;
(function (Pattern) {
    Pattern["Stripes"] = "Stripes";
    Pattern["Polka Dots"] = "Polka Dots";
    Pattern["Floral"] = "Floral";
    Pattern["Paisley"] = "Paisley";
})(Pattern = exports.Pattern || (exports.Pattern = {}));
//# sourceMappingURL=ribbingAttributes.js.map